<template>
    <div class="tw-flex tw-items-center tw-content-center tw-h-full tw-w-full">
        <div class="form-success tw-text-center tw-ml-auto tw-w-full tw-text-white tw-pb-5">
            <h4>Obrigado pelo<br>seu registo</h4>
            <p>Será contactado em breve para saber mais detalhes sobre a recepção da sua amostra</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormSuccess',
};
</script>

<style lang="scss">
@import '~@/assets/scss/partials/_variables.scss';
.form-success {
    
    h4 {
        font-weight: 700;
        font-size: 20px;
        margin-bottom: 7.5px;
        line-height: 1.2;
    }

    p {
        font-size: 16px;
        line-height: 1.2;
    }
}

</style>
